import styled from '../../styles/styled';
import { Flex } from '../layout/flex';
export const Wrapper = styled.div({
    display: 'flex',
    height: '40px',
    width: '100%',
    background: '#FFFFF',
});
export const IconWrapper = styled(Flex)({
    height: '100%',
    width: '40px',
    transition: 'background .1s linear',
    fontSize: '1em',
    cursor: 'pointer',
}, ({ active, theme }) => {
    if (!active) {
        return {
            ':hover': {
                background: theme.colors.grey10,
            },
        };
    }
    return {
        background: theme.colors.azure,
    };
});
export const LeftToolbar = styled(Flex)({
    justifyContent: 'flex-start',
    width: '33.333%',
});
export const CenterToolbar = styled(Flex)({
    width: '33.333%',
});
export const RightToolbar = styled(Flex)({
    justifyContent: 'flex-end',
    width: '33.333%',
});
//# sourceMappingURL=top_toolbar.styles.js.map